var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M13.984 13.834l-1.05-2.7H5.066l-1.05 2.7H4.5a.9.9 0 0 1 0 1.8H1.8a.9.9 0 0 1 0-1.8h.284l4.4-11.312a2.7 2.7 0 0 1 5.032 0l4.4 11.312h.284a.9.9 0 0 1 0 1.8h-2.7a.9.9 0 0 1 0-1.8h.484zm-8.218-4.5h6.468L9.84 3.174a.9.9 0 0 0-1.678 0l-2.395 6.16zm11.334 8.1a.9.9 0 0 1 0 1.8H.9a.9.9 0 0 1 0-1.8h16.2z", id: "svg790410585a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg790410585b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg790410585a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg790410585a" }),
      React.createElement(
        "g",
        { mask: "url(#svg790410585b)", fill: "currentColor" },
        React.createElement("path", { d: "M-1 0h20v20H-1z" })
      )
    )
  );
});